import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Svg from '../svgIcon';
import './styles.scss';

class Checkbox extends Component {
    static defaultProps = {
        checked: false,
        children: null,
        tabIndex: 0,
    }

    static propTypes = {
        name: PropTypes.string.isRequired,
        checked: PropTypes.bool,
        onSelect: PropTypes.func.isRequired,
        className: PropTypes.string.isRequired,
        iconType: PropTypes.string.isRequired,
        iconSize: PropTypes.string.isRequired,
        children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
        tabIndex: PropTypes.number,
    }

    constructor(props) {
        super(props);
        this.onCheckChanged = this.onCheckChanged.bind(this);
    }

    onCheckChanged() {
        const { onSelect, name } = this.props;
        onSelect(name);
    }

    render() {
        const {
            name,
            checked,
            className,
            iconType,
            iconSize,
            children,
            tabIndex,
        } = this.props;
        const iconName = `checkbox-${iconType}-${iconSize}`;
        const checkedIconName = `${iconName}-active`;
        return (
            <div
                className={classNames('bs-checkbox', className, {
                    [`${className}_checked`]: checked,
                })}
            >
                <div className="bs-checkbox__icon">
                    <input
                        className="bs-checkbox__input"
                        name={name}
                        id={name}
                        type="checkbox"
                        checked={checked}
                        onChange={this.onCheckChanged}
                        tabIndex={tabIndex}
                    />
                    <Svg
                        iconName={checkedIconName}
                        size={iconSize}
                        className={classNames('bs-checkbox__image', { 'bs-hidden': !checked })}
                    />
                    <Svg
                        iconName={iconName}
                        size={iconSize}
                        className={classNames('bs-checkbox__image', { 'bs-hidden': checked })}
                    />
                </div>
                {
                    children ?
                    (
                        <label
                            className="bs-checkbox__label"
                            htmlFor={name}
                        >
                            {children}
                        </label>
                    ) : null
                }
            </div>
        );
    }
}

export default Checkbox;



// WEBPACK FOOTER //
// /src/js/common/checkbox/Checkbox.jsx